import { ChangeLogDialogLocalStorageState } from 'src/types/changeLog.types';
import type { LogChange } from 'Types/common.types';

export type BuildChangeLogArgs = {
  changelog: LogChange[];
  unreadChanges: LogChange[];
};

export const buildChangeLog = (args: BuildChangeLogArgs) => {
  const { changelog, unreadChanges } = args;
  const changes: LogChange[] = [...changelog];

  if (unreadChanges.length > 0) {
    return [...unreadChanges];
  }

  return changes;
};

export const buildUnreadChangeLogs = (changelog: LogChange[], lastSeen?: number) => {
  if (lastSeen === undefined) {
    return [];
  }

  return changelog.filter((change: LogChange) => change.timestamp > lastSeen);
};

export enum ChangelogDialogAction {
  open = 'open',
  close = 'close',
}

type ChangeLogDialogArgs = {
  open?: boolean;
  openOnUnreadChanges?: boolean;
  isThereUnreadLogs?: boolean;
};

export const calculateChangelogDialogAction = (
  args: ChangeLogDialogArgs
): ChangelogDialogAction => {
  if (args?.open === true) {
    return ChangelogDialogAction.open;
  }

  if (args?.openOnUnreadChanges === true && args.isThereUnreadLogs === true) {
    return ChangelogDialogAction.open;
  }

  return ChangelogDialogAction.close;
};

export const getPersistentChangelogInitialStateFn =
  (lastMessageTimestamp: number) => (initialChangelogLocalStorage?: string) => {
    const initialState = {
      lastSeen: lastMessageTimestamp,
      showUnreadChanges: true,
    };

    if (!initialChangelogLocalStorage) {
      return initialState;
    }

    try {
      const initialState2: ChangeLogDialogLocalStorageState = initialChangelogLocalStorage
        ? (JSON.parse(initialChangelogLocalStorage) as ChangeLogDialogLocalStorageState)
        : {
            lastSeen: -1,
            showUnreadChanges: true,
          };

      return initialState2;
    } catch (error) {
      return initialState;
    }
  };

export const getPersistentChangelogInitialState = getPersistentChangelogInitialStateFn(0);
